<template>
  <div class="btn-group d-flex flex-column">
    <v-btn
      class="action-btn"
      :loading="isCleaningOrder"
      :disabled="isCleaningOrder"
      @click="onCleanOrder"
    >
      <span class="mr-2 icoiusa-plus-circle"></span>
      Limpiar Pedido
    </v-btn>
    <v-btn class="action-btn" @click="goToHistoryOrdersView">
      <div class="d-flex align-center text-overflow-container">
        <span class="icoiusa-check-circle"></span>
        <span class="mr-2 icoiusa-group-circle"></span>
        <span> Historial de Pedidos </span>
      </div>
    </v-btn>
    <v-btn v-if="!isBackorder" class="action-btn" @click="goToUploadFileView">
      <span class="mr-2 icoiusa-cloud-upload"></span>
      Cargar Archivo
    </v-btn>
    <v-btn
      v-if="!isBackorder"
      class="action-btn yellow-button"
      @click="openPromotionsInNewTab"
    >
      <span class="mr-2 icoiusa-asterisk-circle-outline"></span>
      Promociones
    </v-btn>
    <v-btn
      v-if="!isBackorder && isNewOrder"
      class="action-btn yellow-button"
      @click="$emit('onClickClearance')"
    >
      <v-icon class="mr-2">mdi-sale</v-icon>
      Liquidaciones
      <v-chip class="ma-1 text-white" color="error" small>
        <v-progress-circular
          v-if="loadingMaterials"
          size="10"
          width="2"
          color="white"
          indeterminate
        />
        <template v-else>{{ clearanceMaterialsCount }}</template>
      </v-chip>
    </v-btn>
    <div v-if="!isBackorder" class="btn-spc-order-2">
      <shopping-card
        :show-title="false"
        style="background-color: #67c3d0"
        class="w-full pt-0 mt-0"
      >
        <v-switch
          v-model="scheduleOrder"
          dense
          color="primary"
          class="d-inline-block pt-0 mt-0 pa-0 pb-0 mb-0"
          hide-details
        >
          <template #label>
            <span
              label-position="left"
              class="font-size-9 text-white font-weight-bold"
              >Pedido Programado</span
            >
          </template>
        </v-switch>
      </shopping-card>
      <v-menu
        v-if="scheduleOrder"
        v-model="scheduleOrderMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        min-width="auto"
        offset-y
      >
        <template #activator="{ on, attrs }">
          <v-text-field
            v-model="scheduleOrderDate"
            label="Fecha programada"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="scheduleOrderDate"
          :min-date="scheduleOrderMinDate"
          is-required
          @input="closeScheduleOrderDatePicker"
        />
      </v-menu>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters, mapActions } from 'vuex';
  import { OrderDoctypes } from '@/core/constants/orderDoctypeConstants';

  import Promotions from '@/mixins/promotionsSubmenu';
  import ShoppingCard from './ShoppingCard.vue';

  export default {
    name: 'ShoppingCartActionButtons',
    components: {
      ShoppingCard,
    },
    mixins: [Promotions],
    props: {
      doctype: { type: String, default: null },
      isBackorder: { type: Boolean },
      archive: { type: Boolean },
      orderId: { type: Number, default: null },
    },
    data: () => {
      return {
        isCleaningOrder: false,
        scheduleOrder: false,
        scheduleOrderMenu: false,
        scheduleOrderDate: moment().add(1, 'day').format('YYYY-MM-DD'),
        scheduleOrderMinDate: moment().add(2, 'day').format('YYYY-MM-DD'),
      };
    },
    computed: {
      ...mapGetters('auth', ['user']),
      ...mapGetters('clearanceMaterials', [
        'loadingMaterials',
        'clearanceMaterialsCount',
      ]),
      ...mapGetters('ordercart', ['cart']),
      isNewOrder() {
        return (
          this.doctype === OrderDoctypes.PRIVATE_CHANNEL ||
          this.doctype === OrderDoctypes.RETAIL_CHANNEL
        );
      },
      backorderDeletableItems() {
        return this.cart.filter((item) => !item.backorder_id);
      },
    },
    watch: {
      scheduleOrder: {
        handler(scheduleOrder) {
          if (scheduleOrder) {
            this.scheduleOrderDate = moment()
              .add(1, 'days')
              .format('YYYY-MM-DD');
          }
          this.$emit('scheduleOrder', this.scheduleOrder);
          this.$emit('scheduleOrderDate', this.scheduleOrderDate);
        },
        immediate: true,
      },
    },
    methods: {
      ...mapActions('ordercart', ['cleanMaterialOrder', 'deleteMaterialOrder']),
      async onCleanOrder() {
        this.isCleaningOrder = true;

        try {
          if (this.isBackorder) {
            await this.cleanBackorder();
          } else {
            await this.cleanOrder();
          }

          this.$toast.success('Se limpió el pedido');
          this.$emit('orderCleaned');
        } catch (error) {
          this.$toast.error('No se pudo limpiar el pedido');
        } finally {
          this.isCleaningOrder = false;
        }
      },
      async cleanOrder() {
        await this.cleanMaterialOrder({ order_id: this.orderId });
      },
      async cleanBackorder() {
        await Promise.all(
          this.backorderDeletableItems.map((item) =>
            this.deleteMaterialOrder({ order_id: this.orderId, item })
          )
        );
      },
      goToHistoryOrdersView() {
        this.$router.push({ name: 'HistoryOrders' });
      },
      goToUploadFileView() {
        this.$emit('openArchive');
      },
      async openPromotionsInNewTab() {
        await this.getPromotioPathButton();
      },
      closeScheduleOrderDatePicker() {
        this.scheduleOrderMenu = false;
        const dateOffset = new Date().getTimezoneOffset() * 60000;

        this.scheduleOrderDate = new Date(this.scheduleOrderDate - dateOffset)
          .toISOString()
          .slice(0, 10);
        this.$emit('scheduleOrder', this.scheduleOrder);
        this.$emit('scheduleOrderDate', this.scheduleOrderDate);
      },
    },
  };
</script>

<style scoped>
  .action-btn {
    box-shadow: inset 0px 2px 6px #00000029, 0px 2px 6px #00000029;
    font-weight: 900;
    text-transform: capitalize;
  }

  .yellow-button {
    background-color: #f7dca6 !important;
  }

  .btn-group > *:not(:last-child) {
    margin-bottom: 8px;
  }
  @media screen and (max) {
  }

  @media screen and (min-width: 960px) and (max-width: 1350px) {
    .text-overflow-container {
      max-width: 210px;
      white-space: wrap;
    }
  }
</style>
